import React, { useState, useEffect } from "react";
import { Card, Grid } from "@material-ui/core";
import { CardBody, CardHeader, CardTitle, Input } from "reactstrap";
import "./Admintab.css";
import img1 from "../../assets/ivy_logo.png";
import Button from "../../Components/Button";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  Progress,
  Modal,
  ModalHeader,
  ModalFooter,
  Form,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../variables/api";
import Select from "react-select";
import { Translate } from "src/utils/Translate";
interface IConfiData {
  employees: Array<any>;
}

function Admintab(props: any) {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const [ConfiData, setConfiData] = useState<IConfiData>({
    employees: [],
  });

  const [completed, setCompleted] = useState([]);
  const [uncompleted, setUncompleted] = useState([]);
  const [avg, setAvg] = useState([]);
  const [modal, setModal] = useState(false);
  const [teacheroptions, setTeacherOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const t = new Translate();
  const handleModal = () => {
    setModal(true);
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/tickets/departmentpreformance.php`)
      .then((res: any) => {
        setCompleted(res.data.data.completed);
        setUncompleted(res.data.data.uncompleted);
        setAvg(res.data.data.avg);
        const newOptions: { value: string; label: string }[] =
          res.data.data.employees?.map((teacher: any) => {
            return {
              value: teacher.officialemail,
              label: `${teacher.displayname}- ${teacher.jobtitle}`,
            };
          });

        setTeacherOptions(newOptions);
        const assigned: { value: string; label: string }[] =
          res.data.data.employees?.map((teacher: any) => {
            return res.data.data.assigned?.map((found: any) => {
              if (found.email === teacher.officialemail) {
                return {
                  value: teacher.officialemail,
                  label: `${teacher.displayname}- ${teacher.jobtitle}`,
                };
              }
            });
          });
        setConfiData((prevstate: any) => ({
          ...prevstate,
          employees: assigned,
        }));
      });
  }, []);

  const submitHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      Swal.showLoading();

      const res = await axios
        .post(`${BASE_URL}/tickets/appointemployees.php`, ConfiData)
        .then((res: any) => {
          Swal.fire("Added Successfully", "", "success");
          setModal(false);
        });
    } catch (e) {
      let ee = e as any;

      Swal.fire(
        ee?.response?.data.msg || "Failed to Connect Please refresh",
        "",
        "error"
      );
    }
  };

  const handleEmployeesSelect = async (selectedOption: any) => {
    setConfiData((prevstate: any) => ({
      ...prevstate,
      employees: selectedOption,
    }));
  };
  return (
    <div>
      <Link
        style={{ marginTop: "2%" }}
        to="/"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>
      <Card>
        <button
          className="btn btn-primary"
          style={{ marginLeft: "6%", marginTop: "2%" }}
          onClick={() => {
            navigate("/config");
          }}
        >
          {t.translate("Configure")}
        </button>
        <button
          className="btn btn-primary"
          style={{ marginLeft: "6%", marginTop: "2%" }}
          onClick={() => {
            navigate("/configdept");
          }}
        >
          {t.translate("Department Permissions")}
        </button>

        <CardBody md={12} sm={12} xs={12}>
          {props.departments?.map((dt: any, index: any) => {
            return (
              <Card
                key={`ticklet-${index}`}
                style={{
                  border: "3px solid",
                  borderColor: "#3278bd",
                  margin: "5%",
                }}
              >
                <CardTitle
                  color="#3278bd"
                  style={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#3278bd",
                  }}
                >
                  {t.translate("Department")} : {t.translate(dt.department)}
                </CardTitle>
                <CardBody md={12} sm={12} xs={12}>
                  <div className="table-responsive">
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>
                            {t.translate("Number of Completed Tickets")}
                          </th>
                          <th style={{ textAlign: "center" }}>
                            {t.translate("Number of Unhandeled tickets")}
                          </th>
                          <th style={{ textAlign: "center" }}>
                            {t.translate("Avg time for completeing Tickets")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            {completed[index]}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {uncompleted[index]}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {Math.ceil(avg[index])} days
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </CardBody>
      </Card>
      <Modal isOpen={modal}>
        <ModalHeader>{t.translate("Grant Employee Access")}</ModalHeader>
        <ModalBody>
          <Form onSubmit={submitHandler}>
            <label>{t.translate("Employees")}</label>
            <Select
              options={teacheroptions}
              isMulti
              isClearable
              defaultValue={ConfiData.employees[0]}
              onChange={handleEmployeesSelect}
            />
            <Input
              type="submit"
              disabled={ConfiData.employees == []}
              className="btn btn-primary "
              style={{ backgroundColor: "blue", marginTop: "5%" }}
              value={t.translate("Submit")}
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={() => setModal(false)}>
            {t.translate("Cancel")}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Admintab;
